export const TYPE_WHERE_SCREEN = 'screen';
export const TYPE_WHERE_ACTION = 'action';
export const TYPE_WHERE_HIT = 'hitCounter';
